export default __webpack_public_path__ + "static/media/FLOWDIA_loading.f442507d.mp4";